import * as React from "react";
const SvgPhone = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 28,
	height: 46,
	viewBox: "0 0 28 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M22.292 0.0834961H5.62533C2.75033 0.0834961 0.416992 2.41683 0.416992 5.29183V40.7085C0.416992 43.5835 2.75033 45.9168 5.62533 45.9168H22.292C25.167 45.9168 27.5003 43.5835 27.5003 40.7085V5.29183C27.5003 2.41683 25.167 0.0834961 22.292 0.0834961ZM13.9587 43.8335C12.2295 43.8335 10.8337 42.4377 10.8337 40.7085C10.8337 38.9793 12.2295 37.5835 13.9587 37.5835C15.6878 37.5835 17.0837 38.9793 17.0837 40.7085C17.0837 42.4377 15.6878 43.8335 13.9587 43.8335ZM23.3337 35.5002H4.58366V6.3335H23.3337V35.5002Z",
	fill: "#003366"
}));
export default SvgPhone;
